<evc-modal id="evc-modal" [showReduceButton]="false" [showCloseButton]="false" width="478px" height="260px">
  <ng-content modal-content>
    <div class="modal-content">
      <div class="top-content">
        <div class="main-label">{{ "migration.failure.title" | translate }}</div>
        <div class="secondary-label">{{ "migration.failure.subtitle" | translate }}</div>
      </div>
      <evc-button class="action-button" [textContent]="'migration.failure.retry' | translate" (click)="retry()"></evc-button>
    </div>
  </ng-content>
</evc-modal>
